import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import { typeEstruturaTodasAtvs } from './estrutura_todas_atvs';
import { HeaderDef } from './gerarPDFTodasAtivs';
import { logo_ttivos_base64 } from '../../../../../../../Components/GerarExcel/meta';
import secureLocalStorage from "react-secure-storage";

export const gerarExcelTodasAtivs = async (
    dados: typeEstruturaTodasAtvs[],
    incluir_insumos: boolean,
    incluir_patrimonios: boolean,
    headerInfo?: HeaderDef
) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Relatório de Atividades', {
        views: [{ showGridLines: false }]
    });

    worksheet.columns = [
        { header: '', key: 'col1', width: 40 },
        { header: '', key: 'col2', width: 20 },
        { header: '', key: 'col3', width: 25 },
        { header: '', key: 'col4', width: 15 },
        { header: '', key: 'col5', width: 25 },
        { header: '', key: 'col6', width: 15 },
    ];

    let currentRow = 1;

    // ** HEADER **
    worksheet.getRow(currentRow).height = 40; // Linha para a imagem
    worksheet.getRow(currentRow + 1).height = 30; // Linha para o título
    worksheet.getRow(currentRow + 2).height = 20; // Linha para razao social

    // LOGO
    const headerImageId = workbook.addImage({
        base64: logo_ttivos_base64,
        extension: 'png',
    });

    worksheet.addImage(headerImageId, {
        tl: { col: 2.2, row: 0 },
        ext: { width: 121, height: 50 },
        editAs: 'LOGO TTIVOS'
    });
    worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
    const logoRow = worksheet.getRow(currentRow);
    logoRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
    for (let i = 1; i <= 6; i++) {
        logoRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;

    worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
    const titleRow = worksheet.getRow(currentRow);
    titleRow.getCell(1).value = headerInfo?.titulo || 'Relatório de atividades planejadas';
    titleRow.getCell(1).font = { size: 16, bold: true };
    titleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    for (let i = 1; i <= 6; i++) {
        titleRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;
    worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
    const razaoRow = worksheet.getRow(currentRow);
    razaoRow.getCell(1).value = headerInfo?.razaoSocial || '';
    razaoRow.getCell(1).font = { size: 10 };
    razaoRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    for (let i = 1; i <= 6; i++) {
        razaoRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;

    // ** CLIENTE **
    if (headerInfo?.cliente) {
        worksheet.getRow(currentRow).height = 10; // Espaçamento superior
        currentRow++;

        worksheet.getRow(currentRow).height = 20;
        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
        const clienteRow = worksheet.getRow(currentRow);
        clienteRow.getCell(1).value = `Cliente: ${headerInfo.cliente}`;
        clienteRow.getCell(1).font = { size: 12, bold: true };
        clienteRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
        currentRow++;
    }

    currentRow++; // linha vazia

    const applyBorders = (rowNum: number, color = 'FF000000') => {
        const row = worksheet.getRow(rowNum);
        for (let i = 1; i <= 6; i++) {
            row.getCell(i).border = {
                top: { style: 'thin', color: { argb: color } },
                left: { style: 'thin', color: { argb: color } },
                bottom: { style: 'thin', color: { argb: color } },
                right: { style: 'thin', color: { argb: color } }
            };
        }
    };

    dados.forEach((propriedade) => {
        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
        const propRow = worksheet.getRow(currentRow);
        propRow.getCell(1).value = propriedade.nome_propriedade || "PROPRIEDADE NÃO INFORMADA";
        propRow.getCell(1).font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 12 };
        propRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF5DA57D' } };
        propRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
        propRow.height = 25;
        applyBorders(currentRow, 'FF165C13');
        currentRow++;

        propriedade.lista_atividades_por_talhao.forEach((talhao) => {
            worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
            const talhaoRow = worksheet.getRow(currentRow);
            talhaoRow.getCell(1).value = talhao.nome_talhao || "TALHÃO NÃO INFORMADO";
            talhaoRow.getCell(1).font = { bold: true, color: { argb: 'FF165C13' }, size: 11 };
            talhaoRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
            talhaoRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
            talhaoRow.height = 20;
            applyBorders(currentRow, 'FF165C13');
            currentRow++;

            const headerTitles = ['Atividade', 'Operação', 'Datas', 'Área', 'Área executada', 'Concluída'];
            const colHeaderRow = worksheet.getRow(currentRow);
            headerTitles.forEach((title, index) => {
                const cell = colHeaderRow.getCell(index + 1);
                cell.value = title;
                cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0E743F' } };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
            colHeaderRow.height = 20;
            applyBorders(currentRow, 'FF000000');
            currentRow++;

            let globalAtvIndex = 0;

            talhao.lista_atividades.forEach((atv) => {

                const formatarData = (dInicio: string | null, dFim: string | null) => {
                    if (!dInicio && !dFim) return '-';
                    const i = dInicio ? dayjs(dInicio).format("DD/MM/YY") : '?';
                    const f = dFim ? dayjs(dFim).format("DD/MM/YY") : '?';
                    if (i === f) return i;
                    return `${i} - ${f}`;
                };

                const dataStr = formatarData(atv.data_inicio, atv.data_final);
                const zebraColor = (globalAtvIndex % 2 === 0) ? 'FFFFFFFF' : 'FFE5F1E1';

                const atvRow = worksheet.getRow(currentRow);
                atvRow.getCell(1).value = atv.descricao || '-';
                atvRow.getCell(2).value = atv.tipo_operacao || '-';
                atvRow.getCell(3).value = dataStr;
                atvRow.getCell(4).value = `${atv.area} ha`;
                atvRow.getCell(5).value = `${atv.area_executada} ha (${atv.porcentagem_executada}%)`;
                atvRow.getCell(6).value = atv.concluido ? 'SIM' : 'NÃO';

                atvRow.height = 25;

                for (let i = 1; i <= 6; i++) {
                    const cell = atvRow.getCell(i);
                    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                }

                if (atv.concluido) {
                    atvRow.getCell(6).font = { bold: true, color: { argb: 'FFFFFFFF' } };
                    atvRow.getCell(6).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF01C16C' } };
                } else {
                    atvRow.getCell(6).font = { bold: true, color: { argb: 'FF000000' } };
                }

                applyBorders(currentRow, 'FF000000');
                currentRow++;

                if (incluir_insumos || incluir_patrimonios) {

                    if (incluir_insumos) {
                        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                        const insumosHeaderRow = worksheet.getRow(currentRow);
                        insumosHeaderRow.getCell(1).value = '    Insumos Planejados';
                        insumosHeaderRow.getCell(1).font = { bold: true, size: 10 };
                        insumosHeaderRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
                        insumosHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                        applyBorders(currentRow, 'FF000000');
                        currentRow++;

                        if (atv.insumos && atv.insumos.length > 0) {
                            atv.insumos.forEach((insu: any) => {
                                const detalhes = () => {
                                    switch (insu?.cod_tipo) {
                                        case 8:
                                            return `Tipo: ${insu.nome_tipo || '-'} | Doses: ${insu.doses_inoculante || '-'} | Dosagem: ${insu.dosagem || 0} ${insu.nome_medida || ''}/ha | Qtde: ${insu.quantidade_insumo || 0}`;
                                        default:
                                            return `Tipo: ${insu.nome_tipo || '-'} | Dosagem: ${insu.dosagem || 0} ${insu.nome_medida || ''}/ha | Qtde: ${insu.quantidade_insumo || 0}`;
                                    }
                                };
                                worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                                const insuRow = worksheet.getRow(currentRow);
                                insuRow.getCell(1).value = {
                                    richText: [
                                        { text: `        • ${insu.insumo_nome || '-'}\n`, font: { bold: true, size: 10 } },
                                        { text: detalhes(), font: { size: 9, color: { argb: 'FF4D4D4D' } } }
                                    ]
                                };
                                insuRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
                                insuRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                                insuRow.height = 30;
                                applyBorders(currentRow, 'FF000000');
                                currentRow++;
                            });
                        } else {
                            worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                            const insuRow = worksheet.getRow(currentRow);
                            insuRow.getCell(1).value = `        Não possui insumos cadastrados`;
                            insuRow.getCell(1).font = { size: 9, italic: true, color: { argb: 'FF4D4D4D' } };
                            insuRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
                            insuRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                            applyBorders(currentRow, 'FF000000');
                            currentRow++;
                        }
                    }

                    if (incluir_patrimonios) {
                        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                        const patHeaderRow = worksheet.getRow(currentRow);
                        patHeaderRow.getCell(1).value = '    Patrimônios Planejados';
                        patHeaderRow.getCell(1).font = { bold: true, size: 10 };
                        patHeaderRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
                        patHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                        applyBorders(currentRow, 'FF000000');
                        currentRow++;

                        if (atv.patrimonios && atv.patrimonios.length > 0) {
                            atv.patrimonios.forEach((pat: any) => {
                                const label = pat.horimetro_inicial || pat.horimetro_final ? 'Horímetro' : 'Quilometragem';
                                worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                                const patRow = worksheet.getRow(currentRow);
                                patRow.getCell(1).value = {
                                    richText: [
                                        { text: `        • ${pat.patrimonio_nome || pat.nome || '-'}\n`, font: { bold: true, size: 10 } },
                                        { text: `          ${label} inicial: ${pat.horimetro_inicial ?? pat.quilometragem_inicial ?? '-'} | ${label} final: ${pat.horimetro_final ?? pat.quilometragem_final ?? '-'}`, font: { size: 9, color: { argb: 'FF4D4D4D' } } }
                                    ]
                                };
                                patRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
                                patRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                                patRow.height = 30;
                                applyBorders(currentRow, 'FF000000');
                                currentRow++;
                            });
                        } else {
                            worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                            const patRow = worksheet.getRow(currentRow);
                            patRow.getCell(1).value = `        Não possui patrimônios cadastrados`;
                            patRow.getCell(1).font = { size: 9, italic: true, color: { argb: 'FF4D4D4D' } };
                            patRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
                            patRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                            applyBorders(currentRow, 'FF000000');
                            currentRow++;
                        }
                    }

                }

                globalAtvIndex++;
            });
            currentRow++; // empty space between talhoes
        });
        currentRow++; // empty space between propriedades
    });

    // ** FOOTER **
    const espacoRow = worksheet.addRow([]);
    espacoRow.height = 20;

    const email_usuario_logado = secureLocalStorage.getItem('Itens')?.[0]?.email?.toLowerCase() || '';
    const footerRow = worksheet.addRow([]);
    footerRow.getCell(1).value = `Gerador por: ${email_usuario_logado} - ${dayjs().format('DD/MM/YYYY HH:mm:ss')}`;
    footerRow.font = { italic: true };
    footerRow.alignment = { horizontal: 'center', vertical: 'middle' };

    for (let i = 1; i <= 6; i++) {
        worksheet.getCell(`${String.fromCharCode(64 + i)}${footerRow.number}`).border = {
            top: { style: 'thin', color: { argb: '5da57d' } }
        };
    }
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);
    footerRow.height = 25;

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer as BlobPart], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `Relatorio_Atividades_${dayjs().format("DD_MM_YYYY_HH_mm")}.xlsx`);
};
